import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
@Directive({
  selector: '[ivDoubleClick]'
})
export class DoubleClickDirective implements OnInit, OnDestroy {
  @Input() debounceTime = 500;
  @Output() debounceClick;
  clicks;
  subscription$: Subscription;

  constructor() {
    this.debounceClick = new EventEmitter();
    this.clicks = new Subject();
  }

  ngOnInit() {
    this.subscription$ = this.clicks
    .pipe(
      debounceTime(this.debounceTime)
    )
    .subscribe(e => this.debounceClick.emit(e));
  }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }

  ngOnDestroy() {
    if (this.subscription$) {
      this.subscription$.unsubscribe();
    }
  }

}
